<template>
  <div>
    <!-- Committee list -->
    <div>
      <vs-table
        id="committee-list"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="800px"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        :max-items="length"
        search
        :data="records"
      >
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <div class="flex flex-wrap items-center">
              <!-- Custom Pagination -->
              <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-1"></vs-pagination>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th>User Name</vs-th>
          <vs-th>Email</vs-th>
          <vs-th>Gurudwara Name</vs-th>
          <vs-th v-if="checkPermissionSlug(['committee_revoke_access'])">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td class="text-left">
              <p class="capitalize">{{ `${tr.first_name} ${tr.last_name}` || '-' }}</p>
            </vs-td>
            <vs-td class="text-left">
              <p>{{ tr.email || '-' }}</p>
            </vs-td>
            <vs-td class="text-left">
              <p class="capitalize">{{ tr.gurudwara ? tr.gurudwara.name : '-' }}</p>
            </vs-td>
            <vs-td v-if="checkPermissionSlug(['committee_revoke_access'])">
              <div class="inline-flex">
                <vx-tooltip :text="`${module_name} Accees Revoke`" v-if="checkPermissionSlug(['committee_revoke_access'])">
                  <feather-icon @click.stop="revokeAccess(tr._id, `${tr.first_name} ${tr.last_name}`)" icon="UserXIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'CommitteeList',

  /** Data */
  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    module_name: 'Committee',
    route_slug: 'committee',
    breadcrumb: []
  }),

  /** computed */
  computed: {
    ...mapState('committee', ['records', 'total', 'FilteredCount', 'listLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
  },

  /** Functions */
  methods: {
    ...mapActions('committee', {
      accessUsersList: 'accessUsersList',
      revokeAccessUser: 'revokeAccessUser'
    }),

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** Committee List API */
    getData() {
      this.accessUsersList({
        // order: this.order,
        limit: this.length,
        page: this.page,
        search: this.search,
        committee: this.$route.params.id
      })
    },

    /** Delete Committee Confirmation */
    revokeAccess(id, name) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Access Revoke`,
        text: `Are you sure you want to remove access '${name}' this record?`,
        accept: () => this.revokeAccessById(id),
        acceptText: 'Revoke Access'
      })
    },

    /** Delete Committee API */
    async revokeAccessById(id) {
      try {
        const { message } = await this.revokeAccessUser(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    }
  },

  /** Watchers */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    listLoading() {
      if (this.listLoading) {
        this.$vs.loading({
          container: '#committee-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#committee-list > .con-vs-loading')
      }
    },
    page() {
      this.getData()
    }
  },

  /** On Rendering */
  async mounted() {
    this.getData()

    const committeeId = this.$route.params.id
    if (committeeId) {
      await this.$store.dispatch('committee/show', committeeId).then(async (res) => {
        const data = res.data.data
        this.breadcrumb = [
          { title: 'Dashboard', url: '/dashboard' },
          { title: 'Committee', url: '/committee/list' },
          { title: data.name, url: `/committee/${committeeId}/access-users` },
          { title: 'Access Users', active: true }
        ]
      })
    }
  }
}
</script>
